import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ExchangeCountState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/exchange-count";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { memo } from "react";

export const ExchangeCountDetails = memo(function ExchangeCountDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<ExchangeCountState>) {
  return (
    <RedoTextInput
      description="The total number of previous exchanges for each item in this return. All items must satisfy this condition."
      inputTypeHint="number"
      label="Previous exchanges less than"
      min={1}
      onBlur={() => setState((+state).toFixed(0))}
      setValue={(e) => setState(e)}
      size="sm"
      state={disabled ? "disabled" : "default"}
      value={state}
    />
  );
});
